// extracted by mini-css-extract-plugin
export default {"container":"Oj-z","bubbleNav":"Pj-z","graphic":"Qj-z","contact":"Rj-z"};